export default "__VITE_ASSET__7df142be__"